import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DetailsContractorsLienReleases.css';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import AddLienReleaseForm from 'components/admin/work-orders/details/contractors-lien-releases/AddLienReleaseForm';
import { uploadContractorLienReleaseRequest } from 'actions/admin/work-orders/details/details';
import { getContractorLienRelease } from 'selectors/admin/work-orders/details/details';

class DetailsContractorsLienReleases extends Component {
  handleDocumentDrop = (file) => {
    this.props.dispatch(
      uploadContractorLienReleaseRequest(this.props.currentWorkOrder.id, file)
    );
  };

  render() {
    return (
      <div className="details-contractors-lien-releases">
        <AddLienReleaseForm
          fileUrl={
            this.props.contractorLienRelease !== null
              ? this.props.contractorLienRelease.document.document.url
              : null
          }
          onDocumentDrop={this.handleDocumentDrop}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    contractorLienRelease: getContractorLienRelease(state),
    currentWorkOrder: getCurrentWorkOrder(state),
  };
})(DetailsContractorsLienReleases);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/contractors-lien-releases/DetailsContractorsLienReleases.js